import React from "react";
import TransactionListASAP from "./TransactionListASAP"
import stylesASAP from "./stylesASAP"

export default class Return extends React.Component {

    constructor() {
        super();
        this.state = {
            isVendor: -1
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        const isVendor = JSON.parse(localStorage.getItem("isVendor"));
        if (isVendor) {
            await this.setState({ isVendor: 2 });
        }
        else {
            await this.setState({ isVendor: 0 });
        }
        localStorage.setItem('TransactionType', JSON.stringify(this.state.isVendor));
    }

    render() {
        if (this.state.isVendor !== -1) {
            return (
                <div>
                    <TransactionListASAP type={this.state.isVendor} history={this.props.history} delivery={true}></TransactionListASAP>
                </div>
            );
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesASAP.spinner}></div>
                    </div>
                </div >
            )
        }
    }
}